import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = {
  id: "main",
  tabindex: "-1"
}
const _hoisted_3 = {
  class: "hero",
  "aria-labelledby": "hero-title"
}
const _hoisted_4 = { class: "container hero__layout" }
const _hoisted_5 = { class: "hero__copy" }
const _hoisted_6 = {
  class: "hero__visual",
  "aria-label": "Allading app previews"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  id: "experience",
  class: "experience",
  "aria-labelledby": "experience-title"
}
const _hoisted_10 = { class: "container" }
const _hoisted_11 = { class: "screen-gallery" }
const _hoisted_12 = ["src", "alt", "width", "height"]
const _hoisted_13 = { class: "screen-story__label" }
const _hoisted_14 = {
  id: "features",
  class: "features",
  "aria-labelledby": "features-title"
}
const _hoisted_15 = { class: "container" }
const _hoisted_16 = { class: "feature-grid" }
const _hoisted_17 = {
  class: "trust-strip",
  "aria-labelledby": "trust-title"
}
const _hoisted_18 = { class: "container trust-strip__layout" }
const _hoisted_19 = { "aria-label": "Privacy and account controls" }
const _hoisted_20 = {
  id: "download",
  class: "download",
  "aria-labelledby": "download-title"
}
const _hoisted_21 = { class: "container" }

import SiteFaq from "@/components/site/SiteFaq.vue";
import SiteNav from "@/components/site/SiteNav.vue";
import SiteFooter from "@/components/site/SiteFooter.vue";
import StoreButtons from "@/components/site/StoreButtons.vue";
import inbox from "@/assets/1.webp";
import conversation from "@/assets/2.webp";
import settings from "@/assets/3.webp";
import call from "@/assets/4.webp";

export default /*@__PURE__*/_defineComponent({
  __name: 'LandingView',
  setup(__props) {

const screens = [
  {
    label: "Chats",
    title: "Find your conversation.",
    image: inbox,
    width: 852,
    height: 1846,
    alt: "Chat list with search, unread badges and group filters",
    caption: "Your chats, organised in one place.",
    text: "Search your chats, filter unread messages and find your groups. Preview the latest message before opening a conversation.",
  },
  {
    label: "Messages",
    title: "More than a line of text.",
    image: conversation,
    width: 853,
    height: 1844,
    alt: "Conversation with messages, a voice recording and grouped call history",
    caption: "Text, voice notes and call history together.",
    text: "Send text, photos and voice notes. Reply, react and edit your own text messages, with call summaries kept in the conversation.",
  },
  {
    label: "Calls",
    title: "Hear a familiar voice.",
    image: call,
    width: 853,
    height: 1844,
    alt: "Outgoing voice call with video, mute and end call controls",
    caption: "Voice and video, right from your chat.",
    text: "Start a voice or video call. Control your microphone, switch audio output and turn video on when you want to be seen.",
  },
  {
    label: "Settings",
    title: "Make it yours.",
    image: settings,
    width: 591,
    height: 1280,
    alt: "Settings showing PIN backup, privacy information and mesh diagnostics",
    caption: "Backup and privacy controls within reach.",
    text: "Manage your encrypted key backup, review privacy and security information, and explore the in-app guide.",
  },
];
const features = [
  {
    title: "Direct & group chats",
    text: "Keep one-to-one conversations and group discussions together. Groups use ordinary cloud history.",
  },
  {
    title: "Voice notes & photos",
    text: "Record a voice message when typing is not enough, or share a photo from your phone.",
  },
  {
    title: "Voice & video calls",
    text: "Call from a conversation and see the outcome in your chat history. Calls require an internet connection.",
  },
  {
    title: "Contact requests",
    text: "Find people and review incoming contact requests before adding them to your contacts.",
  },
  {
    title: "Message controls",
    text: "Reply, react, edit your own text and delete your messages. Deleted messages leave a marker in the conversation.",
  },
  {
    title: "Send when reconnected",
    text: "An outbox keeps pending messages and retries delivery when your connection returns.",
  },
];

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SiteNav),
    _createElementVNode("main", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[0] || (_cache[0] = _createElementVNode("p", { class: "eyebrow" }, "Allading messenger", -1)),
            _cache[1] || (_cache[1] = _createElementVNode("h1", { id: "hero-title" }, [
              _createTextVNode(" Your people."),
              _createElementVNode("br"),
              _createElementVNode("span", null, "Your conversations.")
            ], -1)),
            _cache[2] || (_cache[2] = _createElementVNode("p", { class: "hero__lede" }, " A message, a voice note, a familiar face. Keep your everyday conversations together, with secure chats when privacy matters most. ", -1)),
            _createVNode(StoreButtons, { tone: "light" }),
            _cache[3] || (_cache[3] = _createElementVNode("a", {
              class: "text-link",
              href: "#experience"
            }, [
              _createTextVNode("Take a look inside "),
              _createElementVNode("span", { "aria-hidden": "true" }, "↓")
            ], -1)),
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "hero__facts" }, [
              _createElementVNode("span", null, "Chats & voice notes"),
              _createElementVNode("span", null, "Voice & video calls"),
              _createElementVNode("span", null, "Two chat modes")
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("img", {
              class: "hero__secondary screenshot",
              src: _unref(conversation),
              alt: "Conversation with text, a voice message and call history",
              width: "853",
              height: "1844"
            }, null, 8, _hoisted_7),
            _createElementVNode("img", {
              class: "hero__primary screenshot",
              src: _unref(inbox),
              alt: "Allading chat list with unread and group filters",
              width: "852",
              height: "1846",
              fetchpriority: "high"
            }, null, 8, _hoisted_8),
            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "hero__caption" }, "Less distance. More conversation.", -1))
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "section-head" }, [
            _createElementVNode("p", { class: "eyebrow" }, "Inside Allading"),
            _createElementVNode("h2", { id: "experience-title" }, [
              _createTextVNode(" From a quick hello"),
              _createElementVNode("br"),
              _createTextVNode("to a longer catch-up. ")
            ]),
            _createElementVNode("p", null, " Chats, messages, calls and settings. A closer look at your everyday conversations. ")
          ], -1)),
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(screens, (screen) => {
              return _createElementVNode("figure", {
                key: screen.title,
                class: "screen-story"
              }, [
                _createElementVNode("img", {
                  class: "screenshot",
                  src: screen.image,
                  alt: screen.alt,
                  width: screen.width,
                  height: screen.height,
                  loading: "lazy",
                  decoding: "async"
                }, null, 8, _hoisted_12),
                _createElementVNode("figcaption", null, [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(screen.label), 1),
                  _createElementVNode("h3", null, _toDisplayString(screen.title), 1),
                  _createElementVNode("p", null, _toDisplayString(screen.text), 1)
                ])
              ])
            }), 64))
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "section-head" }, [
            _createElementVNode("p", { class: "eyebrow" }, "Made for everyday connection"),
            _createElementVNode("h2", { id: "features-title" }, "Everything close at hand.")
          ], -1)),
          _createElementVNode("ul", _hoisted_16, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(features, (feature) => {
              return _createElementVNode("li", {
                key: feature.title
              }, [
                _createElementVNode("h3", null, _toDisplayString(feature.title), 1),
                _createElementVNode("p", null, _toDisplayString(feature.text), 1)
              ])
            }), 64))
          ])
        ])
      ]),
      _cache[15] || (_cache[15] = _createStaticVNode("<section id=\"security\" class=\"security\" aria-labelledby=\"security-title\" data-v-f1debfe8><div class=\"container\" data-v-f1debfe8><div class=\"section-head\" data-v-f1debfe8><p class=\"eyebrow\" data-v-f1debfe8>Privacy, with a clear choice</p><h2 id=\"security-title\" data-v-f1debfe8> Different conversations.<br data-v-f1debfe8>Different ways to keep them. </h2><p data-v-f1debfe8> Choose the chat mode that fits your conversation. Secure chats and ordinary chats handle history differently. </p></div><div class=\"mode-grid\" data-v-f1debfe8><article data-v-f1debfe8><span class=\"mode-label\" data-v-f1debfe8>Secure chat</span><h3 data-v-f1debfe8>Between your devices.</h3><p data-v-f1debfe8> Messages are end-to-end encrypted using the Signal Protocol. The server relays encrypted content and keeps it for a limited time. Compare safety numbers or QR codes with your contact to verify the connection. </p><span class=\"mode-note\" data-v-f1debfe8>For private, device-based conversations</span></article><article data-v-f1debfe8><span class=\"mode-label\" data-v-f1debfe8>Ordinary chat</span><h3 data-v-f1debfe8>History that comes with you.</h3><p data-v-f1debfe8> Keep your conversation history in the cloud and restore it when you sign in on another device. This mode uses server-managed encryption and is also used for group chats; it is not end-to-end encrypted. </p><span class=\"mode-note\" data-v-f1debfe8>For cloud history and group conversations</span></article></div><div class=\"security-notes\" data-v-f1debfe8><div data-v-f1debfe8><h3 data-v-f1debfe8>A backup you control</h3><p data-v-f1debfe8> Enable a PIN-protected encrypted key backup in Settings. Keep your PIN safe so you can restore your keys. </p></div><div data-v-f1debfe8><h3 data-v-f1debfe8>A clear transport policy</h3><p data-v-f1debfe8> Cloud connectivity is the main way to send messages and make calls. Android Bluetooth and Wi-Fi mesh tools are diagnostic features, not a guaranteed offline messaging service. </p></div></div></div></section>", 1)),
      _createElementVNode("section", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _cache[11] || (_cache[11] = _createElementVNode("div", null, [
            _createElementVNode("p", { class: "eyebrow" }, "Privacy & terms"),
            _createElementVNode("h2", { id: "trust-title" }, "Your choices, explained."),
            _createElementVNode("p", null, " Read how chat modes work, review the service rules or request account deletion. Find the details before you share. ")
          ], -1)),
          _createElementVNode("nav", _hoisted_19, [
            _createVNode(_component_router_link, { to: "/legal" }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                _createTextVNode("Explore privacy & terms ", -1),
                _createElementVNode("span", { "aria-hidden": "true" }, "↗", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: "/privacy" }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createTextVNode("How we handle information ", -1),
                _createElementVNode("span", { "aria-hidden": "true" }, "→", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: "/delete-account" }, {
              default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                _createTextVNode("Delete your account ", -1),
                _createElementVNode("span", { "aria-hidden": "true" }, "→", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ]),
      _createVNode(SiteFaq),
      _createElementVNode("section", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _cache[12] || (_cache[12] = _createElementVNode("p", { class: "eyebrow" }, "Take the conversation with you", -1)),
          _cache[13] || (_cache[13] = _createElementVNode("h2", { id: "download-title" }, "Say hello on Allading.", -1)),
          _cache[14] || (_cache[14] = _createElementVNode("p", null, " Create your profile, find your contacts and choose how you chat. Register with your email and a password, then verify your email with a code. ", -1)),
          _createVNode(StoreButtons, { tone: "dark" })
        ])
      ])
    ]),
    _createVNode(SiteFooter)
  ]))
}
}

})